// Appends the shared app key (k=) to every request to our PHP API
// (andiamotravelapp.com/api and /api-dev), so the paid-service gate
// (src/dataBase/api/_gate.php) can tell app traffic from other callers.
// A query parameter, not a header: a custom header would trigger a CORS
// preflight that several older endpoints don't handle. The key isn't truly
// secret (it ships in the bundle) — server-side caps are the protection.
const KEY = process.env.REACT_APP_APP_GATE_KEY;
const API_URL = /^https:\/\/andiamotravelapp\.com\/api(-dev)?\//;

export function withAppKey(url) {
  if (!KEY || typeof url !== "string" || !API_URL.test(url) || /[?&]k=/.test(url)) return url;
  return url + (url.includes("?") ? "&" : "?") + "k=" + encodeURIComponent(KEY);
}

export function installAppKeyFetch() {
  if (!KEY || typeof window === "undefined" || window.__appGateKeyInstalled) return;
  window.__appGateKeyInstalled = true;
  const originalFetch = window.fetch.bind(window);
  window.fetch = (input, init) => originalFetch(typeof input === "string" ? withAppKey(input) : input, init);
}
